import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, X } from "lucide-react";
import { Link } from "react-router-dom";
import NotificationCard from "@/components/business/NotificationCard";

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [inbox, setInbox] = useState({ items: [], unread: 0 });

  const load = () => api.get("/notifications/inbox", { params: { limit: 20 } }).then(({ data }) => setInbox(data));
  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  const markRead = async (nid) => {
    await api.post(`/notifications/${nid}/read`);
    load();
  };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className="relative grid h-9 w-9 place-items-center rounded-md hover:bg-muted"
        aria-label="Notifications"
        data-testid="notif-bell"
      >
        <Bell className="h-4 w-4" />
        {inbox.unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold grid place-items-center">
            {inbox.unread > 9 ? "9+" : inbox.unread}
          </span>
        )}
      </button>
      {open && (
        <div className="fixed sm:absolute right-2 sm:right-0 top-14 sm:top-10 z-50 w-[360px] max-w-[calc(100vw-1rem)] rounded-xl border border-border bg-background shadow-2xl overflow-hidden" data-testid="notif-panel">
          <div className="flex items-center justify-between px-4 py-3 border-b border-border bg-muted/40">
            <div className="font-display font-semibold">Notifications</div>
            <div className="flex items-center gap-1">
              {inbox.unread > 0 && <button onClick={markAll} className="text-[10px] uppercase tracking-wide text-primary">Mark all read</button>}
              <button onClick={() => setOpen(false)} aria-label="Close notifications" className="grid h-7 w-7 place-items-center rounded hover:bg-muted"><X className="h-3.5 w-3.5" /></button>
            </div>
          </div>
          <div className="max-h-[420px] overflow-y-auto">
            {inbox.items.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground">You're all caught up.</div>}
            {inbox.items.map(n => (
              <NotificationCard
                key={n.id}
                compact
                notification={{ id: n.id, title: n.subject, body: n.body, read: n.read, created_at: n.created_at }}
                onMarkRead={markRead}
              />
            ))}
          </div>
          <div className="px-3 py-2 border-t border-border text-right">
            <Button asChild size="sm" variant="ghost" className="text-xs"><Link to="/profile#notifications" onClick={() => setOpen(false)}>Preferences →</Link></Button>
          </div>
        </div>
      )}
    </div>
  );
}
